module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['single', {
      'is-hidden': _vm.singleIsHidden
    }]
  }, [_c('single-header', {
    attrs: {
      "project": _vm.project
    }
  }, [_c('p', [_vm._v("Zissel was a school project in preparation for the final exams.\n        It is a fictitious company with a profound history and well defined traditions\n        when it comes to brewing beer. Now to appeal to a younger audience they\n        offer special flavored beer and a modern website. You can also enter a\n        prize draw after filling out a dynamic form.")])]), _vm._v(" "), _c('single-section', [_c('img', {
    attrs: {
      "src": "assets/projects/zissel/hero.jpg",
      "alt": "Website Hero"
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Logo Redesign"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/projects/zissel/comparison.jpg",
      "alt": "Comparison of the old logo with the new one"
    }
  }), _vm._v(" "), _c('p', [_vm._v("The logo was redesigned. It shows a beer drinking glass surrounded by\n        laurels to emphasize the high-quality product they are creating.\n        On certain pages it has a subtle animation to draw further attention.")]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "assets/projects/zissel/laurels.mp4",
      "autoplay": "",
      "loop": ""
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Playful Product Pallet"
    }
  }, [_c('p', [_vm._v("To introduce new products for the party culture, they have their own\n        section with whitespace around to set focus on them. Again to increases interest,\n        the bottles slide in when scrolled to.")]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "assets/projects/zissel/bottles.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c9eabfd"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/single/zissel.vue
// module id = 125
// module chunks = 0